// Aquí defines los meta títulos y meta descripciones de cada subpágina
export const seoConfig = {
  // Páginas principales
  'home': {
    metaTitle: "Clinica Milito | Especialistas en Cirugía Plástica y Medicina Estética",
    metaDescription: "Especialistas en Cirugía Plástica y Medicina Estética en Buenos Aires con más de 30 años de experiencia. Resultados naturales y atención personalizada."
  },
  'clinica-milito': {
    metaTitle: "Nosotros | Clínica Milito - Equipo Médico Especializado",
    metaDescription: "Conoce a nuestro equipo de cirujanos plásticos liderado por la Dra. Mónica Milito, con más de 30 años de experiencia en cirugía plástica y medicina estética en Buenos Aires."
  },
  'tratamientos': {
    metaTitle: "Tratamientos - Clínica Milito",
    metaDescription: "Descubre nuestros tratamientos estéticos no invasivos en Buenos Aires."
  },
  'cirugias': {
    metaTitle: "Cirugías - Clínica Milito",
    metaDescription: "Especialistas en cirugías plásticas y estéticas con más de 30 años de experiencia."
  },
  'blog': {
    metaTitle: "Blog - Clínica Milito - Expertos en estetica",
    metaDescription: "Blog de Clínica Milito. Especialistas en cirugías plásticas y estéticas con más de 30 años de experiencia."
  },
  'productos': {
    metaTitle: "Nuestras cremas | Clinica Milito",
    metaDescription: "Línea exclusiva de productos dermatológicos y cosméticos Milito."
  },
  'contacto': {
    metaTitle: "Contacto - Clínica Milito",
    metaDescription: "Agenda tu consulta en Clínica Milito. Ubicados en Av. Gral Las Heras 1628, Buenos Aires. Contáctanos al +54 9 11 48140050."
  },
  'profesionales': {
    metaTitle: "Profesionales - Clínica Milito",
    metaDescription: "Nuestro equipo de profesionales. Agenda tu consulta en Clínica Milito. Ubicados en Av. Gral Las Heras 1628, Buenos Aires. Contáctanos al +54 9 11 48140050."
  },

  // Tratamientos
  'relleno-de-labios': {
    metaTitle: "Relleno de Labios | Clínica Milito",
    metaDescription: "Aumento y definición de labios con ácido hialurónico por especialistas."
  },
  'relleno-de-pomulos': {
    metaTitle: "Relleno de Pómulos | Clínica Milito",
    metaDescription: "Tratamiento de relleno de pómulos para mejorar el contorno facial."
  },
  'relleno-de-ojeras': {
    metaTitle: "Relleno de Ojeras | Clínica Milito",
    metaDescription: "Tratamiento especializado para eliminar ojeras con resultados naturales."
  },
  'profhilo': {
    metaTitle: "Profhilo | Clínica Milito",
    metaDescription: "Tratamiento de bioestimulación con ácido hialurónico de última generación."
  },
  'relleno-de-surcos-y-lineas': {
    metaTitle: "Relleno de Surcos y Líneas | Clínica Milito",
    metaDescription: "Tratamiento para eliminar surcos y líneas de expresión."
  },
  'acido-hialuronico': {
    metaTitle: "Ácido Hialurónico | Clínica Milito",
    metaDescription: "Tratamientos con ácido hialurónico para rejuvenecimiento facial."
  },
  'botox': {
    metaTitle: "Botox | Clínica Milito",
    metaDescription: "Tratamiento con Botox para eliminar arrugas y líneas de expresión."
  },
  'rinomodelacion-nariz': {
    metaTitle: "Rinomodelación (Nariz) | Clínica Milito",
    metaDescription: "Modelado nasal no quirúrgico con resultados inmediatos."
  },
  'relleno-menton-y-contorno-mandibular': {
    metaTitle: "Relleno Mentón y Contorno Mandibular | Clínica Milito",
    metaDescription: "Perfilado facial mediante rellenos en mentón y mandíbula."
  },
  'remodelacion-glutea-con-acido-hialuronico': {
    metaTitle: "Remodelación Glútea con Ácido Hialurónico | Clínica Milito",
    metaDescription: "Aumento y definición de glúteos con ácido hialurónico."
  },

  // Cirugías
  'cirugia-de-elevacion-mamaria-o-pexia-mamaria': {
    metaTitle: "Pexia Mamaria - Cirugía de Elevación Mamaria | Clínica Milito",
    metaDescription: "Especialistas en cirugía de elevación mamaria con resultados naturales."
  },
  'lifting': {
    metaTitle: "Lifting Facial | Clínica Milito",
    metaDescription: "Rejuvenecimiento facial quirúrgico por cirujanos expertos."
  },
  'cirugia-de-nariz-rinoplastia': {
    metaTitle: "Rinoplastia - Cirugía de Nariz | Clínica Milito",
    metaDescription: "Cirugía de nariz por especialistas con resultados naturales."
  },
  'cirugia-de-parpados': {
    metaTitle: "Cirugía de Parpados | Clínica Milito",
    metaDescription: "Blefaroplastia por cirujanos plásticos especializados."
  },
  'lifting-de-brazos': {
    metaTitle: "Lifting de Brazos | Clínica Milito",
    metaDescription: "Cirugía para reafirmar y mejorar el contorno de los brazos."
  },
  'cirugia-de-orejas': {
    metaTitle: "Otoplastia - Cirugía de Orejas | Clínica Milito",
    metaDescription: "Corrección quirúrgica de orejas prominentes."
  },
  'cirugia-de-gluteos-gluteoplastia': {
    metaTitle: "Gluteoplastia - Aumento de Gluteos | Clínica Milito",
    metaDescription: "Aumento y modelado de glúteos por cirujanos expertos."
  },
  'lifting-de-piernas': {
    metaTitle: "Lifting de Piernas | Clínica Milito",
    metaDescription: "Cirugía para mejorar el contorno y firmeza de las piernas."
  },
  'mini-lifting': {
    metaTitle: "Mini Lifting Facial | Clínica Milito",
    metaDescription: "Rejuvenecimiento facial mínimamente invasivo."
  },
  'cirugia-de-reduccion-mamaria-en-hombres': {
    metaTitle: "Cirugía de Reducción Mamaria en Hombres | Clínica Milito",
    metaDescription: "Tratamiento de ginecomastia por cirujanos especializados."
  },
  'extraccion-de-biopolimeros': {
    metaTitle: "Extracción de Biopolímeros | Clínica Milito",
    metaDescription: "Eliminación segura de biopolímeros por especialistas."
  },
  'implante-de-menton': {
    metaTitle: "Implante de Mentón | Clínica Milito",
    metaDescription: "Mentoplastia para mejorar el perfil facial."
  },
  'cirugia-post-obesidad': {
    metaTitle: "Cirugía Post Obesidad | Clínica Milito",
    metaDescription: "Cirugía reconstructiva después de pérdida masiva de peso."
  },
  'cirugia-de-aumento-de-mamas': {
    metaTitle: "Mamoplastia de Aumento - Aumento de Mamas | Clínica Milito",
    metaDescription: "Aumento mamario con implantes de última generación."
  },
  'cirugia-de-papada': {
    metaTitle: "Cirugia de Papada | Clínica Milito",
    metaDescription: "Eliminación quirúrgica de papada para mejorar el perfil."
  },
  'cirugia-de-reduccion-mamaria': {
    metaTitle: "Cirugía de Reducción de Mamas | Clínica Milito",
    metaDescription: "Reducción mamaria para mayor comodidad y estética."
  },
  'lipoescultura-modeladora-asistida-por-vaser': {
    metaTitle: "Lipovaser - Lipoescultura Vaser | Clínica Milito",
    metaDescription: "Lipoescultura de última generación con tecnología Vaser."
  },
  'cirugia-de-abdomen-o-dermolipectomia-abdominal': {
    metaTitle: "Cirugía Estética de Abdomen - Dermolipectomia | Clínica Milito",
    metaDescription: "Cirugía de abdomen para eliminar exceso de piel y grasa."
  },

  // Cosmiatría y Aparatología
  'cosmiatria-y-aparatologia': {
    metaTitle: "Cosmiatría y Aparatología - Clínica Milito",
    metaDescription: "Tratamientos faciales y corporales con tecnología de última generación. Rejuvenecimiento, tensado de piel y más."
  },
  'plasma-rico-en-plaquetas': {
    metaTitle: "Plasma rico en plaquetas - Clínica Milito",
    metaDescription: "Tratamiento de rejuvenecimiento con plasma rico en plaquetas."
  },
  'luz-pulsada': {
    metaTitle: "Luz Pulsada - Clínica Milito",
    metaDescription: "Tratamiento con luz pulsada para manchas y rejuvenecimiento."
  },
  'electrodos-ondas-rusas': {
    metaTitle: "Electrodos: Ondas rusas - Clínica Milito",
    metaDescription: "Tonificación muscular con ondas rusas."
  },
  'microneedle': {
    metaTitle: "Microneedle - Clínica Milito",
    metaDescription: "Tratamiento de microagujas para rejuvenecimiento."
  },
  'mesoterapia': {
    metaTitle: "Mesoterapia - Clínica Milito",
    metaDescription: "Tratamiento para celulitis y adiposidad localizada."
  },
  'tratamientos-para-el-acne': {
    metaTitle: "Tratamientos para el Acné - Clínica Milito",
    metaDescription: "Soluciones efectivas para el acné y sus secuelas."
  },
  'drenaje-linfatico-post-operatorio': {
    metaTitle: "Drenaje Linfático post-operatorio - Clínica Milito",
    metaDescription: "Drenaje especializado para después de cirugías."
  },
  'faciales-personalizados': {
    metaTitle: "Faciales personalizados - Clínica Milito",
    metaDescription: "Tratamientos faciales adaptados a cada tipo de piel."
  },
  'drenaje-linfatico-reductor': {
    metaTitle: "Drenaje linfático reductor - Clínica Milito",
    metaDescription: "Técnica de drenaje para reducción de medidas."
  },
  'presoterapia': {
    metaTitle: "Presoterapia - Clínica Milito",
    metaDescription: "Tratamiento de presión neumática para piernas y brazos."
  },
  'punta-de-diamante': {
    metaTitle: "Punta de diamante - Clínica Milito",
    metaDescription: "Microdermoabrasión para renovación de la piel."
  },
  'inyecciones-lipoliticas-asistidas-por-cavitador-cavix': {
    metaTitle: "Inyecciones lipolíticas asistidas por cavitador (CAVIX) - Clínica Milito",
    metaDescription: "Tratamiento reductor con tecnología CAVIX."
  },
  'oxygenesis': {
    metaTitle: "Oxygenesis - Clínica Milito",
    metaDescription: "Tratamiento de oxigenación profunda de la piel."
  },
  'ultherapy': {
    metaTitle: "Ultherapy - Clínica Milito",
    metaDescription: "Lifting no quirúrgico con ultrasonido focalizado."
  },
  'regen-tripolar-o-radiofrecuencia': {
    metaTitle: "Regen tripolar o Radiofrecuencia - Clínica Milito",
    metaDescription: "Tratamiento de tensado y rejuvenecimiento cutáneo."
  },
  'ultracavitacion': {
    metaTitle: "Ultracavitación - Clínica Milito",
    metaDescription: "Reducción de grasa localizada por ultrasonido."
  },
  'peeling': {
    metaTitle: "Peeling - Clínica Milito",
    metaDescription: "Tratamientos de peeling químico para renovación cutánea."
  },
  'sesion-dermatologica': {
    metaTitle: "Sesión dermatológica - Clínica Milito",
    metaDescription: "Consulta y tratamiento dermatológico personalizado."
  },
  //profesionales
  'dr-michael-guibert-milito': {
    metaTitle: "Dr. Michael Guibert Milito - Médico cirujano | Clínica Milito",
    metaDescription: "Conoce al Dr. Michael Guibert Milito, especialista en Cirugía Plástica y Reparadora en Clínica Milito. Atención profesional y personalizada. Agenda tu consulta hoy."
  },
  'dra-monica-milito': {
    metaTitle: "Dra. Mónica Milito - Médica Especialista en Cirugía Plástica y Reparadora | Clínica Milito",
    metaDescription: "Conoce a la Dra. Mónica Milito, especialista en Cirugía Plástica y Reparadora en Clínica Milito. Atención profesional y personalizada. Agenda tu consulta hoy."
  },
  //blog
  'blefaroplastia-o-cirugia-de-parpados-conoce-sus-beneficios': {
    metaTitle: "Blefaroplastía o cirugía de párpados: conocé sus beneficios - Clínica Milito",
    metaDescription: "Blefaroplastía o cirugía de párpados: conocé sus beneficios. Consulta y tratamiento personalizado."
  },
  'como-eliminar-la-papada-beneficios-de-la-cirugia-estetica-para-un-perfil': {
    metaTitle: "Cómo eliminar la papada: beneficios de la cirugía estética para un perfil definido - Clínica Milito",
    metaDescription: "Cómo eliminar la papada: beneficios de la cirugía estética para un perfil definido. Consulta y tratamiento personalizado."
  },
  'rinoplastia-estetica-vs-funcional-diferencias-y-beneficios': {
    metaTitle: "Rinoplastia estética vs. funcional: diferencias y beneficios - Clínica Milito",
    metaDescription: "Rinoplastia estética vs. funcional: diferencias y beneficios. Consulta y tratamiento personalizado."
  },
  'lifting-facial-tipos-resultados-y-recomendaciones': {
    metaTitle: "Lifting facial: tipos, resultados y recomendaciones - Clínica Milito",
    metaDescription: "Lifting facial: tipos, resultados y recomendaciones. Consulta y tratamiento personalizado."
  },
  'todo-lo-que-necesitas-saber-antes-de-hacerte-una-reduccion-de-mamas': {
    metaTitle: "Todo lo que necesitas saber antes de hacerte una reducción de mamas - Clínica Milito",
    metaDescription: "Todo lo que necesitas saber antes de hacerte una reducción de mamas. Consulta y tratamiento personalizado."
  },
  'que-es-la-presoterapia-y-como-ayuda-en-la-recuperacion-postoperatoria': {
    metaTitle: "¿Qué es la presoterapia y cómo ayuda en la recuperación postoperatoria? - Clínica Milito",
    metaDescription: "¿Qué es la presoterapia y cómo ayuda en la recuperación postoperatoria?. Consulta y tratamiento personalizado."
  },
  'microneedling-facial-como-ayuda-a-rejuvenecer-la-piel': {
    metaTitle: "Microneedling facial: ¿Cómo ayuda a rejuvenecer la piel? - Clínica Milito",
    metaDescription: "Microneedling facial: ¿Cómo ayuda a rejuvenecer la piel?. Consulta y tratamiento personalizado."
  },
  'limpieza-facial-con-punta-de-diamante-beneficios-y-cuidados': {
    metaTitle: "Limpieza facial con punta de diamante: Beneficios y cuidados - Clínica Milito",
    metaDescription: "Limpieza facial con punta de diamante: Beneficios y cuidados. Consulta y tratamiento personalizado."
  },
  'masajes-linfaticos-recuperacion': {
    metaTitle: "Masajes linfáticos postoperatorios: ¿Por qué son importantes en la recuperación? - Clínica Milito",
    metaDescription: "Masajes linfáticos postoperatorios: ¿Por qué son importantes en la recuperación?. Consulta y tratamiento personalizado."
  },
}
